import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowRight } from 'lucide-react';
const FAQS = [{
  q: 'What kind of freight do you get?',
  a: 'For our trucks we deal mostly with dry loads and general freight, mostly food grade. For clients using our dispatch service, it\u2019s your call \u2014 what kind of freight do YOU want to haul?'
}, {
  q: 'What kinds of lanes?',
  a: 'We run wherever YOU want to. As a general rule we follow the money, based on your profile.'
}, {
  q: 'Help with insurance or registration?',
  a: 'Absolutely. Our sister company, FleetScale Group, can help with everything you might need \u2014 general liability insurance, bobtail insurance, comp & collision insurance, IFTA filing, KYU setup, and more. There is 30 years of trucking experience there. If we don\u2019t know the answer, we know where to get it.'
}, {
  q: 'Fuel surcharge?',
  a: 'Currently all fuel charges are built into most of the loads. However, if there is a separate FS, you will see 100% of it.'
}, {
  q: 'Where do you find your loads \u2014 relationships or just load boards?',
  a: 'We have relationships directly with brokers, so we get first pick of loads before they hit the general boards. We also use the load boards to great advantage. When someone says \u201Cyou just get loads off the boards, I can do that\u201D \u2014 no you can\u2019t, not like us. We use an integrated AI system to search up to 10 boards at once, hunting for the best loads and helping our dispatchers pick the best ones to go after. That is why our RPM is consistently higher.'
}, {
  q: 'Why 7%? Seems high.',
  a: 'You get what you pay for. Sure, you can go to some non-US-based service, pay 3%, and they will do half the job. They don\u2019t have the software we have, and they can\u2019t get rate cons from Highway or RMIS because they don\u2019t have the access we do. We are 100% US-based, nothing outsourced \u2014 with a system built to do 100% of the job securely, with your safety and security in mind all the time.'
}, {
  q: 'How long have you been in business?',
  a: 'FSG Transport and FleetScale Group have been in Business since January 2026, but the people running it have almost 50 years combined in the trucking industry. We were tired of seeing how the industry was going \u2014 outsiders coming in just to make a dime off the backs of hard-working owner-operators and small fleets. As a retired owner-operator myself, I wanted to build something that does the job right, cares about the owner-operator, and works toward making them successful and happy. That isn\u2019t asking much.'
}, {
  q: 'How many trucks do you currently dispatch for?',
  a: 'This number changes all the time, up and down. But each dispatcher handles between 5\u20138 trucks. They can do this because of the system we have in place.'
}, {
  q: 'How do you handle payment?',
  a: 'As a leased-on driver, you are paid weekly by direct deposit. Clients are billed weekly via ACH or credit card.'
}, {
  q: 'What do you need from me to get started?',
  a: <div className="space-y-4" data-id="element-163">
        <p data-id="element-164">
          Just click the button below to get to the correct page and start your
          journey to a better life — less stress, no BS.
        </p>
        <div className="flex flex-wrap gap-3" data-id="element-165">
          <Link to="/dispatch-services" className="btn-primary py-2 px-4 text-xs" data-id="element-166">
            Dispatching Services
          </Link>
          <Link to="/lease-on-with-fsg" className="btn-outline-dark py-2 px-4 text-xs" data-id="element-167">
            Lease on with us
          </Link>
        </div>
      </div>
}];
export function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  // Split FAQs into two columns for desktop
  const midPoint = Math.ceil(FAQS.length / 2);
  const leftCol = FAQS.slice(0, midPoint);
  const rightCol = FAQS.slice(midPoint);
  const renderFaq = (faq: (typeof FAQS)[0], i: number, offset: number = 0) => {
    const actualIndex = i + offset;
    return <div key={actualIndex} className="border border-steel rounded-sm overflow-hidden bg-white" data-id="element-168">
        <button className="w-full px-5 py-4 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" onClick={() => setOpenIndex(openIndex === actualIndex ? null : actualIndex)} aria-expanded={openIndex === actualIndex} aria-controls={`faq-answer-${actualIndex}`} data-id="element-169">
          <span className="font-bold text-navy pr-4 text-sm md:text-base" data-id="element-170">
            {faq.q}
          </span>
          <ChevronDown className={`w-5 h-5 text-navy/50 shrink-0 transition-transform duration-200 ${openIndex === actualIndex ? 'rotate-180' : ''}`} data-id="element-171" />
        </button>
        <div id={`faq-answer-${actualIndex}`} className={`px-5 overflow-hidden transition-all duration-200 ease-in-out ${openIndex === actualIndex ? 'max-h-60 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-172">
          <p className="text-body text-sm md:text-base font-medium leading-relaxed" data-id="element-173">
            {faq.a}
          </p>
        </div>
      </div>;
  };
  return <section id="faq" className="py-12 lg:py-16 bg-off-white" data-id="element-174">
      <div className="container-custom max-w-6xl" data-id="element-175">
        <div className="text-center mb-10" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-black text-navy mb-3 tracking-tight" data-id="element-177">
            Questions Drivers and Owner-Operators Ask First
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 items-start" data-id="element-178">
          <div className="space-y-4" data-id="element-179">
            {leftCol.map((faq, i) => renderFaq(faq, i, 0))}
          </div>
          <div className="space-y-4" data-id="element-180">
            {rightCol.map((faq, i) => renderFaq(faq, i, midPoint))}
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-181">
          <Link to="/faq" className="inline-flex items-center gap-2 font-bold text-red hover:text-red-700 transition-colors uppercase tracking-wider text-sm" data-id="element-182">
            View All Questions
            <ArrowRight className="w-4 h-4" data-id="element-183" />
          </Link>
        </div>
      </div>
    </section>;
}